import React, {Component, ReactNode} from 'react';
import Items from 'app/components/shop/Items';
import {ShopsStoreProps} from 'app/store/ShopStore';
import {inject, observer} from 'mobx-react';
import I18n from 'app/i18n';

@inject('shopStore')
@observer
export default class ProductItems extends Component<ShopsStoreProps> {
    componentDidMount(): void {
        this.props.shopStore.setShopUrl(null);
    }

    render(): ReactNode {
        const {data: {user: {points}, money_items}} = this.props.shopStore;
        const title = `${I18n.t('menu_links.shop')} - ${I18n.t('money_header')}`;
        return <>
            <h1 className="visually-hidden-title">{title}</h1>
            <Items items={money_items} points={points}/>
        </>;
    }
}
